import api from "../../ApiConfig";
import { Apis } from "../../../config";
import { NotificationManager } from "react-notifications";

const getAllOrderList = async (batch, search = "") => {
  try {
    let result = await api.get(Apis.GetAllOrderDetails, {
      params: {
        batch,
        search, // ✅ send email or phone
      },
    });

    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getAllPreOrderList = async () => {
  try {
    let result = await api.get(Apis.GetAllPreOrderDetails);
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const movePreorderToOrder = async (id) => {
  try {
    let result = await api.post(`${Apis.GetPreOrderUpdate}?id=${id}`);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const deletePreOrder = async (id) => {
  try {
    let result = await api.delete(`${Apis.GetPreOrderDelete}?id=${id}`);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getRazorpayOrderInfo = async (orderId) => {
  try {
    let result = await api.post(Apis.GETrazorOrderInfo, { orderId }); // 👈 send as object
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const checkOrderInOrders = async (orderNumber) => {
  try {
    let result = await api.post(Apis.GetOrderMatch, { number: orderNumber }); // ✅ Fix: rename key
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getOrderCount = async () => {
  try {
    let result = await api.get(Apis.GetAllStatusOrder);
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data; // Assuming the API response contains a `count` property
  } catch (error) {
    console.log(error);
    return null;
  }
};

const runPreorderBatch = async () => {
  try {
    const result = await api.get(Apis.GetPreorderCron);
    if (!result || !result.data || !result.data.success) {
      NotificationManager.error(
        (result && result.data && result.data.message) || "Batch failed"
      );
      return { success: false };
    }
    return { success: true, batchLog: result.data.batchLog };
  } catch (error) {
    console.error("Batch API Error:", error);
    NotificationManager.error("Something went wrong");
    return { success: false };
  }
};

const createAdminOrder = async (payload) => {
  try {
    const result = await api.post(Apis.CreateAdminOrder, payload);

    if (!result || !result.data) {
      NotificationManager.error("No response from server");
      return null;
    }

    if (!result.data.success) {
      NotificationManager.error(result.data.message || "Order creation failed");
      return null;
    }

    NotificationManager.success("Order created successfully");
    return result.data;

  } catch (error) {
    console.error("Create Admin Order Error:", error);
    NotificationManager.error("Something went wrong while creating order");
    return null;
  }
};


export default {
  getAllOrderList,
  getAllPreOrderList,
  movePreorderToOrder,
  deletePreOrder,
  getOrderCount,
  getRazorpayOrderInfo,
  checkOrderInOrders,
  runPreorderBatch,
  createAdminOrder,
};



// WEBPACK FOOTER //
// ./src/components/services/GetOrderDetails/index.js